// Utility for managing language preference and switching for i18n-js

import i18n from "i18n-js";

const LANGUAGE_KEY = "feelperformer_language";

export const languages = {
  EN: "en",
  ES: "es",
};

export function getSavedLanguage() {
  return localStorage.getItem(LANGUAGE_KEY);
}

export function saveLanguage(lang) {
  localStorage.setItem(LANGUAGE_KEY, lang);
}

export function getDefaultLanguage() {
  const saved = getSavedLanguage();
  if (saved) return saved;
  const browser = window.navigator.language || languages.EN;
  return browser.split("-")[0].toUpperCase();
}

export function setLanguage(lang) {
  i18n.locale = lang;
  saveLanguage(lang);
}

export function getCurrentLanguage() {
  return i18n.locale;
}
